<template>
	<section id="calendar-wrapper"
			 class="calendar-section container-fluid section">
		<div class="row">
			<div class="col-xs-12">
				<div ref="calendarRef"
					 class="calendar-wrapper iframe-parent"
					 @mouseenter="$bus.$emit('cursor-toggle', false)"
					 @mouseleave="$bus.$emit('cursor-toggle', true)" />
			</div>
		</div>
	</section>
</template>

<script setup>
const calendarRef = ref(null)

function embedCalendar() {
	/* eslint-disable-next-line */
	(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if (typeof namespace === "string") { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ["initNamespace", namespace]); } else p(cal, ar); return; } p(cal, ar); }; })(window, 'https://app.cal.com/embed/embed.js', 'init')

	Cal('init', 'supersesh', { origin: 'https://cal.com' })

	Cal.ns.supersesh('inline', {
		elementOrSelector: calendarRef.value,
		config: { 'layout': 'month_view', 'theme': 'light' },
		calLink: 'superodd/supersesh',
	})

	Cal.ns.supersesh('ui', { 'theme': 'light', 'cssVarsPerTheme': { 'branding': { 'brandColor': '#121212' } }, 'hideEventTypeDetails': false, 'layout': 'month_view' })
}


function initComponent() {
	embedCalendar()
}

onMounted(() => {
	useAnims(initComponent)
})
</script>

<style lang="scss" scoped>
.calendar-section {
	padding-top: rem-calc(50);
}
</style>